// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__225MC","list":"styles_list__dlJj0"};